import { CommentOutlined } from "@ant-design/icons";
import { cx } from "class-variance-authority";

import * as theme from "./ActivityTimelineComment.css";

export interface ActivityTimelineCommentProps {
    children: React.ReactNode;
    icon?: React.ReactNode;
    className?: string;
}

export function ActivityTimelineComment({
    children,
    icon = <CommentOutlined />,
    className,
}: ActivityTimelineCommentProps) {
    return (
        <div className={cx(theme.root, className)}>
            {icon}
            {children}
        </div>
    );
}
